import { Component } from 'vue-property-decorator';
import { LabelSetting } from '../../../../i18n/locale-helper'
import { storeModules } from '../../../../store';
import { NotificationModule } from '../../../../store/report/report-notification';
import NotificationTaskProcessComponent from './components/notification-task-process/NotificationTaskProcessComponent.vue';
import NotificationHubComponent from './components/notification-hub/NotificationHubComponent.vue';
import { NotificationViewModel } from './notification-view-model';
import { IMessageNotificationServices, MessageNotificationServices } from '../../../../services/message-notifications.service';
import { MessageNotificationResquest } from '../../../../models/message-notification';
import { convertHREF } from '../../../../utils/util';
import reportSendMessageStatusConstant from '../../../../models/report/report-send-message-status.constant';
import { MessageType } from 'element-ui/types/message';
import { SOCKET_METHOD, SOCKET_RECEIVE_MESSAGE_TYPES } from '../../../../common/socket.constants';
import reportNotificationTypeConstant from '../../../../models/report/report-notification-type.constant';
import { NotificationModel } from '../../../../models/report';
import { namespace, Mutation, Getter, State } from 'vuex-class';
import reportNotificatiodefineTypesStore from "../../../../store/report/report-notification/define-types.store";
import { EVENT_BUS, WEBAPP_LAYOUT } from '../../../../common/constants';
import EventBus from '../../../../utils/event-bus';
import { AuthVerified } from '../../../../models/generic/auth-transfer';
import EventTracker from '../../../../utils/event-tracker';
import { TRACKING_EVENTS } from '../../../../common/tracking-event.constants';

const ReportNotificationMutation = namespace(storeModules.ReportNotification, Mutation);
const CommonGetter = namespace(storeModules.Common, Getter);
const CommonState = namespace(storeModules.Common, State);

@Component({
	template: require('./template.html'),
	components: {
		'notification-hub': NotificationHubComponent,
		'notification-task-process': NotificationTaskProcessComponent
	}
})
class NotificationComponent extends NotificationViewModel {

	visibleNotificationList: Boolean = false;
	isShowingHub: Boolean = false;
	tabVisible: string = 'message-notification';

	localizationConfig = LabelSetting.Action;
	statusLocalizationSetting = LabelSetting.Status;
	actionLocalizationSetting = LabelSetting.Action;
	reportLocalizationConfig = LabelSetting.Report;
	messageNotificationService: IMessageNotificationServices;

	@ReportNotificationMutation(reportNotificatiodefineTypesStore.Set.ADD_NOTIFICATIONS)
    addNotification: (notification: any) => void;
    
    @CommonGetter private userSession: AuthVerified;
    @CommonState('webappLayoutMode') webappLayoutMode: string;

    get isWebView() {
        return this.webappLayoutMode === WEBAPP_LAYOUT.WEBVIEW;
    }

	get lblSetting() {
		return LabelSetting.Global;
	}

	/**
	 *
	 */
	constructor() {
		super();
		this.messageNotificationService = new MessageNotificationServices();
	}

    created() {
        const vm = this as any;
		this.$registerModule(storeModules.ReportNotification, new NotificationModule());
		this.$socket.onEvent(SOCKET_METHOD.RECEIVE_MESSAGE, ({ name, data }) => {
            console.log(SOCKET_METHOD.RECEIVE_MESSAGE, '--', name, ' data--', data);
            if (name == SOCKET_RECEIVE_MESSAGE_TYPES.MAILING_STATUS) {
                if (this.isWebView) {
                    return;
                }
                
                // this is hack because mailing service do not save to database immediate
                if (data.length == 0) return;

                let sendMessageLocalized = this.$t('SEND_MESSAGE_SUCCESS').toString();
                let statusFailureLocalized = this.$t(this.reportLocalizationConfig.emailFailed).toString();
                let sentEmailSucessfullyLocalized = this.$t(this.reportLocalizationConfig.sentEmailSucessfully).toString();

                const formatSendMessageContent = "{Status}";
                const formatMaillingContent = "{PersonIdent} - {PersonEmail}: {Status}";
                data.forEach(item => {
                    let sessionId = item.SessionId;

                    // build message content base on type send message or mailling
                    // send message : personId = 0
                    // mailling: person id  >0
                    let message: string = formatSendMessageContent;
                    let messageType: MessageType;
                    if (item.PersonId > 0) {
                        message = formatMaillingContent;
                        message = message.replace("{PersonIdent}", item.PersonIdent);
                        message = message.replace("{PersonEmail}", item.PersonEmail);
                    }

                    switch (item.Code) {
                        case reportSendMessageStatusConstant.InProgess:
                            return;
                        case reportSendMessageStatusConstant.Success:
                            messageType = "success";
                            message = message.replace(
                                "{Status}",
                                sentEmailSucessfullyLocalized
                            );
                            break;
                        case reportSendMessageStatusConstant.NotFoundPerson:
                        case reportSendMessageStatusConstant.NotFoundSender:
                        case reportSendMessageStatusConstant.PersonInvalidEmail:
                        case reportSendMessageStatusConstant.PersonNerverMail:
                        case reportSendMessageStatusConstant.InvalidSenderEmail:
                        case reportSendMessageStatusConstant.EmptyMessage:
                            let statusLocalized = statusFailureLocalized;//this.$t(this.reportLocalizationConfig.emailFailed);
                            messageType = "warning";
                            message = message.replace(
                                "{Status}",
                                statusLocalized +
                                ":" +
                                item.Message
                            );
                            break;
                        case reportSendMessageStatusConstant.Other:
                            sendMessageLocalized = vm.$t('EMAIL_ERROR').toString();
                            messageType = "warning";
                            message = item.Message;
                            break;
                        default:
                            message = item.Message;
                            break;
                    }

                    (messageType === "success" || item.Code === 0)
                        ? EventBus.$emit(EVENT_BUS.RUNNING_TASK.COMPLETE, sessionId)
                        : EventBus.$emit(EVENT_BUS.RUNNING_TASK.FAIL, sessionId);

                    // SHOW ALERT
                    message = convertHREF(message);
                    setTimeout(() => {
                        this.$notify({
                            dangerouslyUseHTMLString: true,
                            title: sendMessageLocalized,
                            type: messageType,
                            duration: 3000,
                            message: message,
                            customClass: messageType || "success"
                        });
                    }, 500);
                    //ADD NOTIFICATION
                    this.addNotification(
                        new NotificationModel({
                            Type: reportNotificationTypeConstant.SendMessage,
                            Title: sendMessageLocalized,
                            Content: message,
                            Data: { SessionId: sessionId, Status: item },
                            DateTime: new Date(Date.now())
                        })
                    );

                });
                this.handleCheckUnread();
                EventBus.$emit(EVENT_BUS.NOTIFICATION.NOTIFICATION_HUB_FETCH_DATA);
            } else if (name == SOCKET_RECEIVE_MESSAGE_TYPES.MAILING_HTML) {
                EventBus.$emit(EVENT_BUS.NOTIFICATION.NOTIFICATION_MAILING_HTML, data);
            }
		});
	}

	mounted() {
		console.log('notification mounted');
        this.storeGetListOfUsers(this.dtUserSearchParam);
        setTimeout(() => {
            this.handleCheckUnread();
        }, 2000)
	}

	calculateWidthBoxNotification() {
		const vm = this as any;
		const bodyRect = window.document.body.getBoundingClientRect();
		const boxRect = (this as any).$refs.notificationHub.getBoundingClientRect();
		const height = bodyRect.height - boxRect.y;
		vm.$refs.notificationHub.style.height = `${height}px`;
	}

	beforeDestroy() {
		this.$unRegisterModule(storeModules.ReportNotification)
	}

	handleCheckUnread() {
        const request = new MessageNotificationResquest();
        request.Condition.UserIds = [this.userSession?.UserInfo?.Id];
		this.messageNotificationService.search(request)
			.then((response: any) => {
				const { TotalUnread } = response;
				this.totalUnread = TotalUnread ? TotalUnread : 0;
			}).catch(err => {
				this.$message.error;
			})
	}

	handleChangeTab(tab: string) {
		this.tabVisible = tab;
	}

	handleOpenNotificationHub() {
		this.isShowingHub = false;
		this.visibleNotificationList = true;
		this.$nextTick(() => {
			this.calculateWidthBoxNotification();
        });
        EventTracker.logEvent({
            FormName: TRACKING_EVENTS.PAGES.GLOBAL,
            Action: TRACKING_EVENTS.EVENTS.OPEN_NOTIFICATION,
            FormId: 0,
            Comment: {}
		});
		
		setTimeout(() => {
			this.isShowingHub = true;
		}, 500);
	}

	handleHideNotificationHub(event) {
		if (!this.isShowingHub || 
				(event.target.className.includes('ico_close-circle') && event.target.className.includes('el-input__clear'))) {
			return;
		}
		this.visibleNotificationList = false;
	}
}

export default NotificationComponent;